import cn from 'classnames';
import { FC } from 'react';

import { AnalyticsTag } from '@/shared/api/transcriptor/transcriptorApi';
import { Tooltip } from '@/shared/ui';

import styles from '../AnalyticsView.module.scss';

type AnalyticsTagChipProps = {
  tag: AnalyticsTag;
};

const mutedTagCodes = ['NotDefined', 'Undefined', 'None'];

export const AnalyticsTagChip: FC<AnalyticsTagChipProps> = (props) => {
  const { tag } = props;
  const isMuted = mutedTagCodes.includes(tag.tag_code);
  const label = tag.tag_name?.trim() || tag.tag_code;
  const chip = (
    <span className={cn(styles.tagChip, isMuted && styles.tagChipMuted)}>
      {label}
    </span>
  );

  if (tag.explanation) {
    return <Tooltip.Primary content={tag.explanation}>{chip}</Tooltip.Primary>;
  }

  return chip;
};
